
import React from 'react';
import { FiBriefcase, FiUser } from 'react-icons/fi';
import { useRemarkSync } from 'react-remark';
import styled from 'styled-components';
import devices from '@/utilities/devices';

// #region STYLE
const TestimonialCardContainer = styled.div<{ backgroundImage: string, isSelected?: boolean }>`
	display: flex;
	margin-right: 50px;
	min-width: 100%;
	opacity: ${({isSelected}) => isSelected ? 1 : 0};
	position: relative;
	transition: opacity 1s;

	.testimonial-image {
		min-width: 360px;
		min-height: 410px;
		background-image: ${({backgroundImage}) => `url(${backgroundImage})`};
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
	}

	.testimonial-content {
		align-self: flex-start;
		display: flex;
		flex-direction: column;
		padding-left: 1.5rem;
		position: relative;
		top: 50px;

		.testimonial-information {
			align-items: center;
			display: flex;
			font-weight: bold;
			div {
				align-items: center;
				color: ${({theme}) => theme.color.prune};
				display: flex;
				:first-child {
					margin-right: 2rem;
				}
				> svg {
					color: ${({theme}) => theme.color.prune};
					height: 22px;
					padding: 6px 10px 10px 0;
					width: 22px;
				}
			}
		}

		.testimonial-review {
			padding: 1.2rem 1rem 0 0;
			span {
				color: ${({theme}) => theme.color.red};
			}
		}
	}

	@media screen and (${devices.mobile}) {
		flex-direction: column;
		transition: opacity .8s;

		.testimonial-image {
			min-width: 330px;
			min-height: 380px;
		}

		.testimonial-content {
			padding: 0 1rem;
			top: 15px;

			.testimonial-information {
				justify-content: center;
			}

			.testimonial-review {
				padding: 1rem 0rem 0 0;
			}
		}
	}
	@media screen and (min-width: 426px) and (max-width: 640px) {
		flex-direction: column;
		transition: opacity .8s;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		transition: opacity 1s;
		.testimonial-image {
			min-width: 310px;
			min-height: 360px;
		}
		.testimonial-content {
			padding: 0 1rem;

			.testimonial-review {
				padding: 1rem 0rem 0 0;
			}
		}
	}
`;
// #endregion

export interface TestimonialProps {
	/**
	 * Image of the talent displayed in the carousel.
	 */
	readonly userPicture: {
		readonly alternativeText?: string,
		readonly caption?: string,
		readonly url: string,
		readonly name: string,
	}
	/**
	 * Name of the talent.
	 */
	readonly userName: string,
	/**
	 * Work position of the talent.
	 */
	readonly userPosition: string,
	/**
	 * Review written by the talent.
	 */
	readonly userDescription: string,
}

// #region COMPONENT
const TestimonialCard = ({ userName, userPosition, userDescription, userPicture, isSelected }: TestimonialProps & { isSelected?: boolean }) => {

	const markdownContent = useRemarkSync(userDescription, {
		rehypeReactOptions: {
			components: {
				p: (props: any) => <React.Fragment {...props}></React.Fragment>,
			},
		},
	});

	// #region RENDER
	return (
		<TestimonialCardContainer backgroundImage={userPicture.url} isSelected={isSelected}>
			<div className='testimonial-image'/>
			<div className='testimonial-content'>
				<div className='testimonial-information'>
					<div> <FiUser /> {userName} </div>
					<div> <FiBriefcase /> {userPosition} </div>
				</div>
				<div className='testimonial-review'>
					<span>“ </span>
					{markdownContent}
					<span> ”</span>
				</div>
			</div>
		</TestimonialCardContainer>
	);
	// #endregion
};
// #endregion

export default TestimonialCard;
